exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hw_stat__content[data-v-20f20500]{flex-direction:column;align-items:flex-start}.homework-menu[data-v-20f20500],.hw_stat__content[data-v-20f20500]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.homework-menu[data-v-20f20500]{flex-shrink:0;align-items:center}", ""]);

// exports
